<!-- <div class="language-modal-wrap">
  <ua-modal>
    <div class="modal-header">
      <div class="close-wrapper" (click)="closeModal()">
        <i (click)="closeModal()" class="material-icons">arrow_back</i><span>Back</span>
      </div>
    </div>
    <div class="modal-body">
      <div class="lang-content">
        <div class="lang-card big">Language Options</div>
        <ng-container *ngFor="let lang of languages">
          <div (click)="changeLanguage(lang)" class="lang-card" [class.selected]="selectedLanguage === lang.locale">
            <div class="heading">{{ lang.value }}</div>
            <div [class.none]="selectedLanguage !== lang.locale" class="tick">
              <img src="../../../assets/tick.png" />
            </div>        
         </div>
        </ng-container>
        <div class="disclaimer">
          <p>*Disclaimer text about agent third party translator tool.</p>
        </div>
      </div>
    </div>
  </ua-modal>
</div> -->
<div class="language-modal-wrap" trapFocus [class.hideModalBackground]="offset && !showModal" [class.none] = "!offset && !showModal">
  <div class="modal modal-container" tabindex="-1" role="dialog" #modal>
    <div class="modal-dialog backdrop" role="document">
      <div class="modal-content" [class.openAnimation] ="showModal" [class.closeAnimation]="offset && !showModal"  [class.hide] = "isLoading" [style.--bottom]='offset?.offsetTop'
        [style.--left]="offset?.offsetLeft">
        <div class="modal-header">
          <button class="close-wrapper unstyle-button" aria-labelledby="backBtn" (click)="closeModal()">
            <i (click)="closeModal()" aria-hidden="true" class="material-icons">arrow_back</i><span id="backBtn">{{pageConstants.back}}</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="lang-content">
            <div class='lang-desc'>
              <p>{{pageConstants.langInfo}} {{pageConstants[currentLang.locale]}} {{pageConstants.langInfoContinued}}</p>
            </div>
            <div class='btn-wrap row'>
              <button class="btn primary" (click)="closeModal()">
                <div class="btn-content">
                  <span class="btn-text">{{pageConstants.langConfirmation}} {{pageConstants[currentLang.locale]}}</span>
                </div>
              </button>
            </div>
            <div class='btn-wrap row'>
              <button class="btn" (click)="storeLangConsent(alternateLang.locale); changeLanguage(alternateLang)">
                <div class="btn-content">
                  <span class="btn-text">{{pageConstants.langDefault}} {{ currentLang.locale === defaultLang ? pageConstants[browserDefault.locale] : pageConstants[defaultLang] }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>